export const APP_TONS = {
  TOKEN: 'krbs-tons',
  ENCRYPTED_DATA: 'vuex-tons',
  ENCRYPTED_SECRET: 'AdjIawtoiuRSjfHyh9Ed',
};

export const KRBS_TONS = {
  LOGIN: 'user-login',

  /** si user routes **/
  USER_LOGOUT: 'user/logOut', //si    protectec connection
  USER_CHANGE_PASS: 'user/change-pass',

  USER_GET_VESSEL: 'user/getVesselList',
  USER_GET_VESSEL_CREW_TONS: 'user/getVesselCrewTons',
  USER_CREW_TON_REMARKS : 'user/crewTonRemarks',
  USER_DOWNLOAD_CREW_TON : 'user/downloadTonFile',

  USER_CUD: 'staff/si-users',

  /** cms user routes **/
  STAFFS_LOGOUT: 'staff/logOut', //staff
  STAFF_CHANGE_PASS: 'staff/change-pass',

  STAFF_GET_VESSEL_PAGINATED: 'staff/getVesselPaginated',
  STAFF_GET_USER_PAGINATED: 'staff/getUserPaginated',
  STAFF_GET_CMS_USER_PAGINATED: 'staff/getCmsUserPaginated',
  STAFF_GET_VESSEL_TON_RANKS: 'staff/getVesselTonRanks',
  STAFF_UPDATE_VESSEL_TON_RANKS: 'staff/updateVesselTonRanks',

  //getCrewKeysPaginated
  STAFF_GET_CREW_KEY_PAGINATED: 'staff/getCrewKeysPaginated',

  //get si vessel routes
  STAFF_GET_USER_VESSELS: 'staff/getAssignedVessels',
  STAFF_ADD_USER_VESSELS: 'staff/addAssignedVessels',
  STAFF_DEL_USER_VESSELS: 'staff/deleteAssignedVessels',

  //routes for crew ton module
  STAFF_GET_VESSEL: 'staff/getVesselList',
  STAFF_GET_VESSEL_CREW_TONS: 'staff/getVesselCrewTons',
  STAFF_CREATE_CREW_TON: 'staff/createCrewTon',
  STAFF_DELETE_CREW_TON: 'staff/deleteCrewTon',
  STAFF_UPDATE_CREW_TON : 'staff/updateCrewTon',

  STAFF_UPLOAD_CREW_TON : 'staff/uploadCrewTonFile',
  STAFF_REPLACE_CREW_TON : 'staff/replaceCrewTonFile',
  STAFF_DOWNLOAD_CREW_TON : 'staff/downloadTonFile',

  STAFF_DELETE_TON_FILE_HISTORY : 'staff/deleteTonFileHistory',
  STAFF_DOWNLOAD_TON_FILE_HISTORY : 'staff/downloadFileHistory',

  //TODO remarks here
  STAFF_CREW_TON_REMARKS : 'staff/crewTonRemarks',

  /** crew user routes **/
  CREW_LOGOUT: 'crew/crew-logOut',  //crew
  CREW_VIEW_CREW_TON: 'crew/viewCrewTon',
  CREW_DOWNLOAD_CREW_TON : 'crew/downloadTonFile',

  /** over all routes **/
};

export default {APP_TONS, KRBS_TONS};
